export const environment = {
  production: false,
  urlApi: 'https://spo6vii9ff.execute-api.us-east-1.amazonaws.com/dev/api/v1',
  // urlApi: 'http://localhost:8016/api/v1',
  firebase: {
    apiKey: 'AIzaSyCnr0JsKzrujEYpMynvheHRo3rx0pe5C2Y',
    authDomain: 'keystoreman.firebaseapp.com',
    databaseURL: 'https://keystoreman.firebaseio.com',
    projectId: 'keystoreman',
    storageBucket: 'keystoreman.appspot.com',
    messagingSenderId: '941236766322',
    appId: '1:941236766322:web:ae259788f50c0e0cce24eb',
    measurementId: 'G-NQNTYB9X8Q',
  },
};
